import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type FeedbackRoutes = {
    feedback: Route
    feedbackSuccess: Route
    feedbackFailed: Route
}

export const feedbackRoutes: FeedbackRoutes = {
    feedback: {
        path: 'dashboard/feedback',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.shop.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-received-reviews/page-received-reviews.component').then(
                (m) => m.PageReceivedReviewsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    feedbackSuccess: {
        path: 'dashboard/feedback-success',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('./page-feedback-success/page-feedback-success.component').then(
                (m) => m.PageFeedbackSuccessComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
    feedbackFailed: {
        path: 'dashboard/feedback-failed',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('./page-feedback-failed/page-feedback-failed.component').then(
                (m) => m.PageFeedbackFailedComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
}
